import React, { FC } from 'react';
import './loader-spinner.scss';

interface IProps {
  customClasses?: string | undefined;
}

const LoaderSpinner: FC<IProps> = ({ customClasses }): JSX.Element => (
  <div className={`half-circle-dots-container ${customClasses}`}>
    <div className='half-circle-dots'></div>
    <div className='half-circle-dots'></div>
  </div>
);

export default LoaderSpinner;
